import React from 'react';
import { useHistory } from 'react-router-dom';
import LogOutIcon from 'mdi-react/LogoutIcon';
import { useAuth } from '../../../shared/components/auth/withAuth';
import env from '../../../Env';
import { post } from '../../../utils/api/base';

const TopbarLogout = () => {
  const auth = useAuth();
  const history = useHistory();

  const handleLogout = async () => {
    try {
      // Call the logout API to clear the httpOnly cookie on the server
      await post(`${env.baseApiUrl}/api/authentication/logout`, {});
    } catch (error) {
      console.error('Logout API error:', error);
    } finally {
      // Clear client-side authentication flag
      auth.signout();
      sessionStorage.clear();
    }
  };

  return (
    <button
      type="button"
      className="topbar__btn topbar__btn--logout"
      onClick={handleLogout}
      title="Logout"
      aria-label="Logout"
    >
      <LogOutIcon />
    </button>
  );
};

export default TopbarLogout;
